"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var colors = {
    white: 'var(--white)',
    cg30: 'var(--cg-30)',
    cg40: 'var(--cg-40)',
    cg50: 'var(--cg-50)',
    cg60: 'var(--cg-60)',
    cg70: 'var(--cg-70)',
    cg80: 'var(--cg-80)',
    cg90: 'var(--cg-90)',
    cg100: 'var(--cg-100)',
    cg200: 'var(--cg-200)',
    cg300: 'var(--cg-300)',
    cg400: 'var(--cg-400)',
    cg500: 'var(--cg-500)',
    cg600: 'var(--cg-600)',
    cg650: 'var(--cg-650)',
    cg700: 'var(--cg-700)',
    cg800: 'var(--cg-800)',
    cg900: 'var(--cg-900)',
    blue50: 'var(--blue-50)',
    blue100: 'var(--blue-100)',
    blue200: 'var(--blue-200)',
    blue300: 'var(--blue-300)',
    blue400: 'var(--blue-400)',
    blue500: 'var(--blue-500)',
    blue600: 'var(--blue-600)',
    blue700: 'var(--blue-700)',
    blue800: 'var(--blue-800)',
    blue900: 'var(--blue-900)',
    green50: 'var(--green-50)',
    green100: 'var(--green-100)',
    green200: 'var(--green-200)',
    green300: 'var(--green-300)',
    greenSlime: 'var(--green-slime)',
    green400: 'var(--green-400)',
    green500: 'var(--green-500)',
    green600: 'var(--green-600)',
    green700: 'var(--green-700)',
    green800: 'var(--green-800)',
    green900: 'var(--green-900)',
    red50: 'var(--red-50)',
    red100: 'var(--red-100)',
    red200: 'var(--red-200)',
    red300: 'var(--red-300)',
    red400: 'var(--red-400)',
    red500: 'var(--red-500)',
    red600: 'var(--red-600)',
    red700: 'var(--red-700)',
    red800: 'var(--red-800)',
    red900: 'var(--red-900)',
    purple50: 'var(--purple-50)',
    purple100: 'var(--purple-100)',
    purple200: 'var(--purple-200)',
    purple300: 'var(--purple-300)',
    purple400: 'var(--purple-400)',
    purple500: 'var(--purple-500)',
    purple600: 'var(--purple-600)',
    purple700: 'var(--purple-700)',
    purple800: 'var(--purple-800)',
    purple900: 'var(--purple-900)',
    khaki50: 'var(--khaki-50)',
    warningContrast: 'var(--warning-contrast)',
    warning: 'var(--warning)',
    khaki100: 'var(--khaki-100)',
    khaki200: 'var(--khaki-200)',
    khaki300: 'var(--khaki-300)',
    khaki400: 'var(--khaki-400)',
    khaki500: 'var(--khaki-500)',
    khaki600: 'var(--khaki-600)',
    khaki700: 'var(--khaki-700)',
    khaki800: 'var(--khaki-800)',
    khaki900: 'var(--khaki-900)',
    bronze50: 'var(--bronze-50)',
    bronze100: 'var(--bronze-100)',
    bronze200: 'var(--bronze-200)',
    bronze300: 'var(--bronze-300)',
    bronze400: 'var(--bronze-400)',
    bronze500: 'var(--bronze-500)',
    bronze600: 'var(--bronze-600)',
    bronze700: 'var(--bronze-700)',
    bronze800: 'var(--bronze-800)',
    bronze900: 'var(--bronze-900)',
    n30: 'var(--neutral-30)',
    n40: 'var(--neutral-40)',
    n60: 'var(--neutral-60)',
    n50: 'var(--neutral-50)',
    n70: 'var(--neutral-70)',
    n80: 'var(--neutral-80)',
    n90: 'var(--neutral-90)',
    n100: 'var(--neutral-100)',
    n200: 'var(--neutral-200)',
    n300: 'var(--neutral-300)',
    n400: 'var(--neutral-400)',
    n500: 'var(--neutral-500)',
    n600: 'var(--neutral-600)',
    n700: 'var(--neutral-700)',
    n800: 'var(--neutral-800)',
    n900: 'var(--neutral-900)',
    bgBrand: 'var(--bg-brand)',
    bgPage: 'var(--bg-page)',
    bgBaseSubtle: 'var(--bg-base-subtle)',
    bgBase: 'var(--bg-base)',
    bgOverlay: 'var(--bg-overlay)',
    bgOverlayInverse: 'var(--bg-overlay-inverse)',
    bgScrim: 'var(--bg-scrim-rgb)',
    bgScrimDark: 'var(--bg-scrim-dark-rgb)',
    bgScrimHovered: 'var(--bg-scrim-hovered)',
    bgScrimPressed: 'var(--bg-scrim-pressed)',
    bgScrimSelected: 'var(--bg-scrim-selected)',
    bgScrimSelectedHovered: 'var(--bg-scrim-selected-hovered)',
    bgScrimSelectedPressed: 'var(--bg-scrim-selected-pressed)',
    bgScrimOverlay: 'var(--bg-scrim-overlay)',
    bgPrimary: 'var(--bg-primary)',
    bgPrimaryHovered: 'var(--bg-primary-hovered)',
    bgPrimaryPressed: 'var(--bg-primary-pressed)',
    bgPrimarySubtle: 'var(--bg-primary-subtle)',
    bgInfo: 'var(--bg-info)',
    bgInfoHovered: 'var(--bg-info-hovered)',
    bgInfoPressed: 'var(--bg-info-pressed)',
    bgInfoSubtle: 'var(--bg-info-subtle)',
    bgPositive: 'var(--bg-positive)',
    bgPositiveHovered: 'var(--bg-positive-hovered)',
    bgPositivePressed: 'var(--bg-positive-pressed)',
    bgPositiveSubtle: 'var(--bg-positive-subtle)',
    bgNegative: 'var(--bg-negative)',
    bgNegativeHovered: 'var(--bg-negative-hovered)',
    bgNegativePressed: 'var(--bg-negative-pressed)',
    bgNegativeSubtle: 'var(--bg-negative-subtle)',
    bgNeutral: 'var(--bg-neutral)',
    bgNeutralHovered: 'var(--bg-neutral-hovered)',
    bgNeutralPressed: 'var(--bg-neutral-pressed)',
    bgNeutralEmphasis: 'var(--bg-neutral-emphasis)',
    bgNeutralEmphasisHovered: 'var(--bg-neutral-emphasis-hovered)',
    bgNeutralEmphasisPressed: 'var(--bg-neutral-emphasis-pressed)',
    bgNeutralSubtle: 'var(--bg-neutral-subtle)',
    bgNeutralSubtleHovered: 'var(--bg-neutral-subtle-hovered)',
    bgNeutralSubtlePressed: 'var(--bg-neutral-subtle-pressed)',
    contentPrimary: 'var(--content-primary)',
    contentPrimaryInverse: 'var(--content-primary-inverse)',
    contentSecondary: 'var(--content-secondary)',
    contentSecondaryInverse: 'var(--content-secondary-inverse)',
    contentTertiary: 'var(--content-tertiary)',
    contentTertiaryInverse: 'var(--content-tertiary-inverse)',
    contentLink: 'var(--content-link)',
    contentLinkHovered: 'var(--content-link-hovered)',
    contentLinkPressed: 'var(--content-link-pressed)',
    contentInfo: 'var(--content-info)',
    contentInfoInverse: 'var(--content-info-inverse)',
    contentInfoEmphasis: 'var(--content-info-emphasis)',
    contentPositive: 'var(--content-positive)',
    contentPositiveInverse: 'var(--content-positive-inverse)',
    contentPositiveEmphasis: 'var(--content-positive-emphasis)',
    contentNegative: 'var(--content-negative)',
    contentNegativeInverse: 'var(--content-negative-inverse)',
    contentNegativeEmphasis: 'var(--content-negative-emphasis)',
    contentWarning: 'var(--content-warning)',
    contentWarningEmphasis: 'var(--content-warning-emphasis)',
    borderNeutral: 'var(--border-neutral)',
    borderNeutralHovered: 'var(--border-neutral-hovered)',
    borderNeutralPressed: 'var(--border-neutral-pressed)',
    borderPrimary: 'var(--border-primary)',
    borderNegative: 'var(--border-negative)',
    borderNegativeHovered: 'var(--border-negative-hovered)',
    borderNegativePressed: 'var(--border-negative-pressed)',
    borderWarning: 'var(--border-warning)',
    borderPositive: 'var(--border-positive)',
    surface50: 'var(--surface-50)',
    surface100: 'var(--surface-100)',
    surface200: 'var(--surface-200)',
    surface300: 'var(--surface-300)',
    surfaceInverse: 'var(--surface-inverse)',
    surfacePrimary: 'var(--surface-primary)',
    surfacePositive: 'var(--surface-positive)',
    surfaceNegative: 'var(--surface-negative)',
    surfaceNegativeHovered: 'var(--surface-negative-hovered)',
    surfaceWarning: 'var(--surface-warning)',
    actionPrimary: 'var(--action-primary)',
    actionPrimaryHovered: 'var(--action-primary-hovered)',
    actionPrimaryPressed: 'var(--action-primary-pressed)',
    actionNegative: 'var(--action-negative)',
    actionNegativeHovered: 'var(--action-negative-hovered)',
    actionNegativePressed: 'var(--action-negative-pressed)',
    contentInverse: 'var(--content-inverse)',
    contentDark: 'var(--content-dark)',
    contentLight: 'var(--content-light)',
    editorBg: '#111723',
    editorText: '#BFBFBF',
    editorSelection: '#73B0FF80',
    editorComment: '#8E929E',
    editorType: '#F5E86E',
    editorString: '#F7F8FA',
    editorNumber: '#94E5AB',
};
exports.default = colors;
//# sourceMappingURL=colors.js.map